import * as RadioGroup from '@radix-ui/react-radio-group'
import * as React from 'react'

import { cn } from '~/styled'
import type { Override } from '~/utilities/types'

import { RadioCard } from './RadioCard'

type RadioCardGroupProps = Override<
  React.ComponentProps<typeof RadioCard>,
  React.ComponentProps<typeof RadioGroup.Root>
>

export const RadioCardGroup = ({
  className,
  children,
  size,
  isFullWidth,
  align,
  ...rest
}: RadioCardGroupProps) => (
  <RadioGroup.Root {...rest}>
    <div className={cn('flex', 'flex-row', 'flex-wrap', 'gap-3', className)}>
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child) && child?.type === RadioCard) {
          return React.cloneElement(
            child as React.ReactElement<React.ComponentProps<typeof RadioCard>>,
            { size, isFullWidth, align }
          )
        }
        return child
      })}
    </div>
  </RadioGroup.Root>
)
